import ReactDOM from 'react-dom';
import useHasMounted from 'hooks/useHasMounted';
function Portal(_ref) {
  var targetElement = _ref.targetElement,
    children = _ref.children;
  if (!useHasMounted()) return null;
  if (targetElement === null) return children;
  return /*#__PURE__*/ReactDOM.createPortal(children, targetElement || document.getElementById('modals-and-popovers') || document.body);
}
export default Portal;